import { FC, useContext, useMemo } from 'react';

import type { MenuProps } from 'antd';
import { Button, Dropdown } from 'antd';
import { MoreOutlined } from '@ant-design/icons';

import { StepTwoFormContext } from '../../../../contexts/StepTwoForm';
import { GenericDataFormContext, QuotationInfoContext } from '../../../../../../../shared/contexts';
import { QuotationStep } from '../../../../../../../shared/interfaces';

interface HeaderTabHomeProps {
  areTabActionsAllowed: boolean
  id: number;
}

export const HeaderTabHome: FC<HeaderTabHomeProps> = ({areTabActionsAllowed, id}) => {

  const { duplicateTab, tabs, setShowModal, setKeyTabToDelete } = useContext(StepTwoFormContext);
  const { currentStep } = useContext(QuotationInfoContext);
  const { userCanDeleteTabs } = useContext(GenericDataFormContext);

  const canNotDeleteTab = useMemo(() => tabs.length === 1 || !userCanDeleteTabs, [tabs, userCanDeleteTabs]);

  const onMenuClick: MenuProps['onClick'] = (e) => {
    if (e.key === '1') {  
      duplicateTab(id);
    } else if (e.key === '2') {
      setKeyTabToDelete(id)
      setShowModal(true);
    }
  };

  const items = [
    {
      key: '1',
      label: 'Duplicar',
    },
    {
      key: '2',
      label: 'Eliminar',
      danger: true,
      disabled: canNotDeleteTab
    }
  ]

  return (
    <>
    {/* Integral de Comercio {tabIndex} */}
    Hogar {id}
    {currentStep === QuotationStep.TWO && areTabActionsAllowed && (
      <Dropdown menu={{ items, onClick: onMenuClick }} trigger={['click']} arrow>
        <Button type='text' style={{ padding: 0, marginLeft: 10 }}>
          <MoreOutlined />
        </Button>
      </Dropdown>
    )}
    </>
  )
};